export function transformPhone(phone: string | undefined | null): string {
  if (!phone) return '';

  return phone[1] === '+' ? phone.substring(1) : phone;
}
